_.namespace(module, function(require) {
  var QuestionDoc, W, exportMapper;
  W = require('when');
  QuestionDoc = require('lib/db_docs/question_doc');
  exportMapper = require('lib/services/cochrane_pivot/export_mapper');
  return {
    _getQuestionData: function(questionModel) {
      var rawQuestion;
      rawQuestion = _.isFunction(questionModel != null ? questionModel.json : void 0) ? questionModel.json() : _.isFunction(questionModel != null ? questionModel.toJSON : void 0) ? questionModel.toJSON() : questionModel;
      try {
        return QuestionDoc.of(rawQuestion).json();
      } catch (_error) {
        return rawQuestion;
      }
    },
    _assertManagementQuestion: function(questionData) {
      var type, _ref;
      type = (_ref = questionData.type) != null ? _ref : 'management';
      if (type !== 'management' && type !== '') {
        throw new Error('unsupportedQuestionType');
      }
    },
    exportQuestion: function(_arg) {
      var error, questionData, questionModel, selectedOutcomes, _ref;
      _ref = _arg != null ? _arg : {}, questionModel = _ref.questionModel, selectedOutcomes = _ref.selectedOutcomes;
      if (!questionModel) {
        return W.reject(new Error('questionModelRequired'));
      }
      try {
        questionData = this._getQuestionData(questionModel);
        if (selectedOutcomes != null) {
          questionData = _.extend({}, questionData, {
            outcomes: _.map(selectedOutcomes, function(outcome) {
              if (_.isFunction(outcome.toJSON)) {
                return outcome.toJSON();
              } else {
                return outcome;
              }
            })
          });
        }
        this._assertManagementQuestion(questionData);
        return W.resolve(exportMapper.exportQuestion(questionData));
      } catch (_error) {
        error = _error;
        return W.reject(error);
      }
    }
  };
});
